import styled from 'styled-components';
import iconContent from '../assets/font/RuiIcon';

interface Props {
  iconName: string;
  color?: string;
  leftOfText?: boolean;
  touch?: boolean;
  size?: number;
}

const BaseIcon = styled.span<Props>`
  &:before {
    font-family: 'rui-icon';
    content: attr(data-icon);
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    display: inline-block;
    ${(props) => `${props.size ? `font-size: ${props.size}px` : ''}`};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    ${(props) => (props.leftOfText ? 'margin-right: 0.25em' : '')};
  }

  ${(props) => (props.color ? `color: ${props.color};` : '')}

  ${(props) =>
    props.touch
      ? `
      position: relative;
      &:after {
        content: " ";
        height: 48px;
        width: 48px;
        position: absolute;
        display: block;
        top: 0;
        left: 0;
        margin-left: -15px;
        margin-top: -15px;
      }
    `
      : ''};
`;

// TODO: due to known issue we use `styled()` instead of `.extend` for now. https://github.com/styled-components/babel-plugin-styled-components/issues/52
const Icon = styled(BaseIcon)`
  &:before {
    content: '${(props) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return iconContent[props.iconName];
    }}';
  }
`;

export default Icon;
